import { ExtensionThicknessValue, LROptions, LROptionsWithoutNone, LRStrictOptions } from '@/store/prescription/prescription-types';

type MappedValue = string;
type CategoryItem = {
	display: string;
	description: string;
	imgPath: string;
};

type BasicValues<T extends string> = { [key in T]: MappedValue };
type ExtendedValues<First extends string, Second extends string> = { firstValue: BasicValues<First>; secondValue: BasicValues<Second> };
type ThirdExtendedValues<First extends string, Second extends string, Third extends string> = {
	firstValue: BasicValues<First>;
	secondValue: BasicValues<Second>;
	thirdValue: BasicValues<Third>;
};
type SelectItem<T extends string> = CategoryItem & { selectValues: BasicValues<T> };
type RadioItem<T extends string> = CategoryItem & { radioValues: BasicValues<T> };
type RadioSelectItem<Radio extends string, Select extends string> = RadioItem<Radio> & SelectItem<Select>;
type RadioSelectExtendedItem<Radio extends string, Select extends string, Select2 extends string> = RadioItem<Radio> &
	SelectItem<Select> & { secondSelectValues: BasicValues<Select2> };
type LRValues<T> = { LR: T };
type LRSelectItem<T extends string> = CategoryItem & LRValues<BasicValues<T>>;
type ExtendedLRSelectItem<Select extends string, FirstExtended extends string, SecondExtended extends string> = SelectItem<Select> &
	LRValues<ExtendedValues<FirstExtended, SecondExtended>>;
type ExtendedListLRSelectItemThird<
	Select extends string,
	FirstExtended extends string,
	SecondExtended extends string,
	ThirdExtended extends string
> = SelectItem<Select> & LRValues<ThirdExtendedValues<FirstExtended, SecondExtended, ThirdExtended>>;

type ExtendedListLRSelectItemOne<Select extends string, FirstExtended extends string> = SelectItem<Select> &
	LRValues<{ firstValue: BasicValues<FirstExtended> }>;

type CheckboxItem = CategoryItem & { checkbox: Array<string> };

export class TypedFactory<C> {
	typeItems<T extends { [key in keyof C]: T[key] }>(factory: T) {
		return factory;
	}
}

export const LRRadio: BasicValues<LROptions> = { none: 'N/A', left: 'L', right: 'R', both: 'B/L' };

export const LRRadioWithoutNone: BasicValues<LROptionsWithoutNone> = { left: 'L', right: 'R', both: 'B/L' };

export const LRStrictRadio: BasicValues<LRStrictOptions> = { left: 'L', right: 'R' };
export const MortonsThickness: BasicValues<ExtensionThicknessValue> = {
	consistent: 'Consistent Shell Thickness',
	'2.5mm': '2.5mm Shell Thickness'
};

export {
	SelectItem,
	RadioItem,
	RadioSelectItem,
	LRValues,
	LRSelectItem,
	ExtendedLRSelectItem,
	CheckboxItem,
	RadioSelectExtendedItem,
	ExtendedListLRSelectItemThird,
	ExtendedListLRSelectItemOne
};
